import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, LOCALE_ID } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { Ng2OdometerModule } from 'ng2-odometer';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {ModalModule} from 'ngx-bootstrap/modal';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ArticlesService } from './services/articles.service';
import { ArticlesComponent } from './articles/articles.component';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { ModalAlertasComponent } from './modal-alertas/modal-alertas.component';
import { OAuthModule } from 'angular-oauth2-oidc';
import { CategoriasComponent } from './components/categorias/categorias.component';
import { GeneralIterceptorService } from './interceptors/general-iterceptor/general-iterceptor.service';
import { HomeComponent } from './components/home/home.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { FichasInformativasComponent } from './components/fichas-informativas/fichas-informativas.component';

@NgModule({
  declarations: [
    AppComponent,
    ArticlesComponent,
    ModalAlertasComponent,
    CategoriasComponent,
    HomeComponent,
    NotFoundComponent,
    FichasInformativasComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    Ng2OdometerModule.forRoot(),
    BrowserAnimationsModule,
    HttpClientModule,
    ScrollingModule,
    NgbModule,
    SharedModule,
    AppRoutingModule,
    ModalModule.forRoot(),
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: ['http://www.angular.at/api'],
        sendAccessToken: true
      }
    })
  ],
  entryComponents: [
    ModalAlertasComponent
  ],
  providers: [
    ArticlesService, 
    { provide: LOCALE_ID, useValue: 'es-CO' },
    { provide: HTTP_INTERCEPTORS, useClass: GeneralIterceptorService, multi: true }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
